module.exports = "/_next/static/images/bbe729b78dc14a9ba95c575855104efb-challenge-the-system-md@1x.jpg.webp";